import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { FRONTEND as SITE_VISITS_ROUTES } from "../../../Router/site_visit_routes";
import { ButtonPrimary } from "../../Button";
import { FRONTEND as ADMIN_ROUTES } from "../../../Router/admin_routes";
import * as VENUE_ROUTES from "../../../Router/venue_routes";
import * as RFP_ROUTES from "../../../Router/rfp_routes";

const VenueDashboardNavigation = ({ newsletterLink }) => {
  const navLinks = [
    {
      label: "My EDGE",
      link: ADMIN_ROUTES.MY_EDGE,
      visible: true,
      color: "#9bcb41",
    },
    {
      label: "Calendar",
      link: VENUE_ROUTES.FRONTEND.VENUE.CALENDAR,
      visible: true,
      color: "#FCA342",
    },
    {
      label: "My RFPs",
      link: RFP_ROUTES.FRONTEND.RFP.VENUES.MY_RFPS,
      visible: true,
      color: "#CB414B",
    },
    {
      label: "Site Visits",
      link: SITE_VISITS_ROUTES.VIEW,
      visible: true,
      color: "#4BC7FE",
    },
    {
      label: "Latest Newsletter",
      link: newsletterLink,
      visible: newsletterLink,
      color: "#E6144C",
      external: true,
    },
  ];

  return (
    <div className="flex flex-wrap items-center w-full mt-8 mb-12">
      <div className="flex items-center flex-wrap">
        {navLinks.map(({ label, link, color, external = false, visible }) => {
          if (!visible) return null;

          const button = (
            <ButtonPrimary
              classes="mr-2 agency-dash-link__home mb-2"
              style={{ width: "inherit", backgroundColor: color }}
            >
              {label}
            </ButtonPrimary>
          );

          return external ? (
            <a href={link} key={link} target="_blank" rel="noopener noreferrer">
              {button}
            </a>
          ) : (
            <Link to={link} key={link}>
              {button}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {};
};

export default connect(mapStateToProps, null)(VenueDashboardNavigation);
